import { VoucherTemplateSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/vouchers/{templateId}
 *
 * Operator-authored voucher templates. Issuance to a customer is via the
 * `issueVoucher` callable — operators never write to
 * `users/{uid}/vouchersHeld/{voucherId}` directly (no cross-user write
 * permission, and we need server-side validation + audit).
 *
 * Path matches firestore.rules `match /vouchers/{voucherId}`; reads are
 * public so the customer-pwa can render template copy on held vouchers.
 */
export function voucherTemplatesRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/vouchers`,
    schema: VoucherTemplateSchema,
    name: `tenants/${tenantId}/vouchers`,
  });
}
